import React from "react";
import { Trans, useTranslation } from "react-i18next";
import homeConfig from "src/resources/homePage.json";
import { ReactComponent as HowCompanyDetails } from "src/assets/icons/home-how-to-register/how-company-details.svg";
import { ReactComponent as HowContacts } from "src/assets/icons/home-how-to-register/how-contracts.svg";
import { ReactComponent as HowInformation } from "src/assets/icons/home-how-to-register/how-information.svg";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";

const HowToRegister = () => {
  const howToRegister = homeConfig.howToRegister;
  const { t } = useTranslation(["homePage"]);
  return (
    <section className="home-section how-to-register w-100 container-fluid" id="how-to-register">
      <Trans>
        <div
          className="how-to-register-bg"
          style={{
            backgroundImage: `url(${require(`src/assets/images/${howToRegister.image.name}`)})`,
            backgroundPosition: "center bottom",
            position: "relative",
            backgroundSize: "100% 63%",
            backgroundRepeat: "no-repeat",
            height: "100%"
          }}
        >
          <div className="main-benefit d-flex justify-content-between align-items-start">
            <section>
              <h1 className="title">{t(`homePage.howToRegister.title`)}</h1>
              <h4 className="sub-title">
                {t(`homePage.howToRegister.subTitle`)}
              </h4>
            </section>
            <section>
              <p className="register-content">
                {t(`homePage.howToRegister.content`)}
              </p>
              <h6 className="item-title">
                {t(`homePage.howToRegister.itemsTitle`)}
              </h6>
              <div className="items">
                {howToRegister.items.map((item, index) => (
                  <div key={index}>
                    <div className="item d-flex align-items-center gap-2 justify-content-start align-items-center">
                      {item.icon === "HowCompanyDetails" && (
                        <HowCompanyDetails />
                      )}
                      {item.icon === "HowContacts" && <HowContacts />}
                      {item.icon === "HowInformation" && <HowInformation />}
                      <p>
                        {t(
                          `homePage.howToRegister.items.item${index + 1}.title`
                        )}
                      </p>
                    </div>
                    {howToRegister.items.length > index + 1 && (
                      <HorizontalDivider className="my-3" />
                    )}
                  </div>
                ))}
              </div>
            </section>
          </div>
        </div>
      </Trans>
    </section>
  );
};

export default HowToRegister;
